import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoggerService } from '../services/logger.service';

@Injectable({
  providedIn: 'root'
})
export class AlreadyDownloadedGuard implements CanActivate {
  constructor(private loggerService: LoggerService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isCordova = this.loggerService.getIsCordova();
    if (isCordova) {
      this.router.navigate(["home"]);
      return false;
    }
    return true
  }
}
